import { createSelector } from 'reselect'
import { getCurrentModalSelect } from 'modules/modal/selectors'
import { getModalIdRouteUtil } from 'modules/routes/utils/get-modal-id'

const hasLocationModalSelect = createSelector(
  getCurrentModalSelect,
  (state, props) => props?.location,
  (modalId, location) => {
    return (
      !!modalId ||
      (
        location && getModalIdRouteUtil(location.pathname)
      )
    )
  }
)

export default hasLocationModalSelect
